import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VmsSubmittalPage } from '../../../enums';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  private activePageSubject = new BehaviorSubject<VmsSubmittalPage>(VmsSubmittalPage.RIGHT_TO_REPRESENT);
  activePage$ = this.activePageSubject.asObservable();

  setActivePage(page: VmsSubmittalPage) {
    this.activePageSubject.next(page);
  }
}
